<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
		</Header>

		<div class="TopTitle" data-aos="fade-right">
			<!-- data-aos="fade-up-left" -->
			<div class="">
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<div class="ContenNewsCenter">

			<div class="newsList" v-for="(item,index) in $store.state.navShow == true ? newsList:newsListE" :key="index" :data-id="item.id"
				@click="upPage(item.id)">
				<div class="newsListTitle">
					<div class="newsListText">
						{{ item.title }}
					</div>
					<div class="newsListTime">
						{{ item.inputtime }}
					</div>
				</div>
				<div class="newsListImg">
					<img :src="item.thumb">
				</div>
			</div>



		</div>
		<div class="onClick">
			<van-loading size="12px" v-if="loading">加载中...</van-loading>
			<div @click="onload" class="onClickText" v-else>↓ 点击加载更多!</div>
		</div>
		<!-- 		<div class="buttonImg">
			<img :src="imgList.bottonImg">
			<img :src="imgList.currency">
		</div> -->
	</div>

</template>

<script>
	import Header from "@/components/header.vue";
	import Toast from 'vant';
	export default {
		components: {
			Header,
		},
		data() {
			return {
				loading: false,
				finished: false,
				pages: 1,
				imgList: {
					bannerImg: require('@/assets/newsCenter/banner.jpg'),
				},
				newsListE:[],
				newsList: [{
						content: "本次恳谈会由河北省人民政府外事办公室、河北省人民对外友好协会和邯郸市人民政府共同主办...",
						id: 8,
						inputtime: "2021-11-26",
						thumb: "http://www.margingroup.cn/uploads/images/20211122/2c069775557e53aff4ffdfcbeca54816.jpg",
						title: "MG+冀欧号 |励志笃行MG+冀欧号 |励志笃行MG+冀欧号 |励志笃行MG+冀欧号 |励志笃行MG+冀欧号 |励志笃行MG+冀欧号 |励志笃行",
					},
				],
			}
		},
		mounted() {

			this.$axios.get('/api/Index/newsList', {
				params: {
					page: this.pages,
					type: 2
				}
			}).then((res) => {
				console.log('新闻列表=>', res);
				if (res.data.code === 1) {
					console.log('1')
					this.newsList = res.data.data.list
				} else {
					this.$message({
						showClose: true,
						message: '新闻中心与关于我们,' + res.data.msg,
						type: 'error'
					})
				}
			})
			this.$axios.get('/apien/Index/newsList', {
				params: {
					page: this.pages,
					type: 2
				}
			}).then((res) => {
				console.log('新闻列表=>', res);
				if (res.data.code === 1) {
					console.log('1')
					this.newsListE = res.data.data.list
				} else {
					this.$message({
						showClose: true,
						message: '新闻中心与关于我们,' + res.data.msg,
						type: 'error'
					})
				}
			})

		},

		methods: {
			/**
			 * 点击加载更多
			 * 罗锦炜
			 * 2021-12-07
			 * */
			onload() {
				this.loading = true;
				this.pages++
				this.$axios.get('/api/Index/newsList', {
					params: {
						page: this.pages,
						type: 2
					}
				}).then((res) => {
					console.log('新闻列表=>', res);
					if (res.data.code === 1) {
						if (res.data.data.list.length > 0) {
							setTimeout(() => {
								this.loading = false;
								this.newsList = this.newsList.concat(res.data.data.list)
							}, 1000);
						} else {
							setTimeout(() => {
								this.loading = false;
								this.$message({
									showClose: true,
									message: '暂无更多',
									type: 'error'
								})
							}, 1000);
						}
					} else {
						this.$message({
							showClose: true,
							message: '新闻中心与关于我们,' + res.data.msg,
							type: 'error'
						})
					}
				})
			},
			/**
			 * 跳转详情页
			 * 罗锦炜
			 * 2021-12-07
			 * */
			upPage(newid) {
				this.$router.push({
					path: '/newsDetail',
					query: {
						newId: newid
					}
				})

			},


		}
	}
</script>
<!-- 头部 -->
<style lang="less">
	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}

	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(
270deg,rgba(3,0,0,.15),hsla(0,0%,100%,.15));
		}
	}
</style>

<style lang="less">
	.ContenNewsCenter {
		width: 90%;
		margin: 0 5%;
		margin-top: -1.25rem;
		margin-bottom: 0.625rem;

		.newsList {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			border-bottom: 1px solid rgba(204, 204, 204, 0.5);
			margin-bottom: 1.28125rem;

			.newsListImg {
				min-width: 8.125rem;
				width: 8.125rem;
				min-height: 4.84375rem;
				height: 4.84375rem;
				margin-bottom: 1.25rem;

				&>img {
					width: 100%;
					height: 100%;
				}
			}

			.newsListTitle {
				height: 100%;
				width: 55%;
				text-align: left;

				.newsListText {

					font-size: 0.875rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					text-align: initial;
					margin-bottom: 1.15625rem;
					margin-top: 0.5625rem;
				}

				.newsListTime {
					font-size: 0.78rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #999;
				}
			}
		}


	}

	.onClick {
		width: 100%;
		height: 2.5rem;
		margin: 0.625rem 0 0.625rem 0;
		font-size: 0.75rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #c8c9cc;
	}




	// 小标题
	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 0.75rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 0.9375rem;
	}
</style>
